module.exports = __webpack_public_path__ + "src/img/ok.d242ff12.svg";